import {transform} from "ol/proj";
import {getLatLonProjectionName} from "@/helpers/ol/ol-projection-helper";
import {getUserName} from "@/helpers/auth/auth-helper.js";
import moment from 'moment';

let PARAMS = [
    '$coordx',
    '$coordy',
    '$coordlat',
    '$coordlon',
    '$straat',
    '$huisnummer',
    '$huisletter',
    '$toevoeging',
    '$woonplaats',
    '$postcode',
    '$gemeente',
    '$gemcode',
    '$perceel',
    '$websiteid',
    '$bookmarkid',
    '$website',
    '$rotatie',
    '$usernaam',
    '$datum'
]

export function hasDefaultValueParams(value) {

    let hasDefaultValueParam = false
    if(value) {
        PARAMS.map(param => {
            if (String(value).includes(param)) {
                hasDefaultValueParam = true
            }
        })
    }

    return hasDefaultValueParam
}

export function replaceDefaultValueParams(result, location, value, center) {

    if(value) {
        PARAMS.map(param => {
            if (String(value).includes(param)) {

                let replacer = result[param.replace('$', '')]
                if(!replacer) {
                    replacer = ''
                }

                const xy = transform(center, 'EPSG:28992', getLatLonProjectionName())

                switch (param) {
                    case '$coordx':
                        replacer = center[0].toFixed(0)
                        break;
                    case '$coordy':
                        replacer = center[1].toFixed(0)
                        break;
                    case '$coordlat':
                        replacer = xy[1].toFixed(6)
                        break;
                    case '$coordlon':
                        replacer = xy[0].toFixed(6)
                        break;
                    case '$straat':
                        replacer = location.straatnaam
                        break;
                    case '$huisnummer':
                        replacer = location.huisnummer
                        break;
                    case '$huisletter':
                        replacer = location.huisletter
                        break;
                    case '$toevoeging':
                        replacer = location.toevoeging
                        break;
                    case '$woonplaats':
                        replacer = location.woonplaatsnaam
                        break;
                    case '$postcode':
                        replacer = location.postcode
                        break;
                    case '$gemeente':
                        replacer = location.gemeentenaam
                        break;
                    case '$gemcode':
                        replacer = location.gemeentecode
                        break;
                    case '$perceel':
                        replacer = result.perceel.weergavenaam
                        break;
                    case '$buurtnaam':
                        replacer = location.buurtnaam
                        break;
                    case '$websiteid':
                    case '$bookmarkid':
                        replacer = window.websiteID
                        break;
                    case '$website':
                        replacer = window.websiteName
                        break;
                    case '$rotatie':
                        replacer = window.map.getView().getRotation()
                        break;
                    case '$usernaam':
                        replacer = getUserName()
                        break;
                    case '$datum':
                        replacer = moment().format('YYYY-MM-DD')
                        break;
                }

                if(replacer !== undefined) {
                    value = value.replaceAll(param, replacer)
                }
            }
        })
    }

    return value
}

